import { trustHTML } from "@ember/template";
import PluginOutlet from "discourse/components/plugin-outlet";
import bodyClass from "discourse/helpers/body-class";
import concatClass from "discourse/helpers/concat-class";
import lazyHash from "discourse/helpers/lazy-hash";
import routeAction from "discourse/helpers/route-action";
import { and, notEq } from "discourse/truth-helpers";
import CirclesBackground from "../components/circles/background";
import CirclesLogo from "../components/circles/logo";
import CirclesMemberActions from "../components/circles/member-actions";
import CirclesMembershipButton from "../components/circles/membership-button";
import CirclesNavigationComboBox from "../components/circles/navigation-combo-box";
import CirclesViewNavigationTabs from "../components/circles/view/navigation-tabs";

const CircleIndex = <template>
  {{bodyClass "circles-view-page"}}

  <PluginOutlet
    @name="circles-view-page"
    @connectorTagName="div"
    @outletArgs={{lazyHash model=@model}}
  >
    <div class="circles-view" data-category-id={{@model.category_id}}>
      <div
        class="circles-info
          {{if @model.hasLogo '--has-logo'}}
          {{if @model.hasBackground '--has-background'}}"
      >
        <CirclesBackground class="circles-info__background" @model={{@model}} />

        <div class="circles-info__name">
          <PluginOutlet
            @name="circles-view-info-name"
            @connectorTagName="div"
            @outletArgs={{lazyHash model=@model}}
          >
            <CirclesNavigationComboBox
              @suggestedType="member"
              @circles={{@controller.group.extras.visible_group_names}}
              @value={{@model.name}}
            />
          </PluginOutlet>
        </div>

        <div class="circles-info__details">
          <CirclesLogo class="circles-info__logo" @model={{@model}} />

          {{#if (notEq @model.definition_raw "")}}
            <div class="circles-info__description">
              <p>{{trustHTML @model.category.description}}</p>
            </div>
          {{/if}}

          {{#each @model.customFields as |field|}}
            {{#if (and field.value field.displayOnIndexHeader)}}
              <div class="circles-info__custom-fields">
                <div
                  class={{concatClass "circles-info__custom-field" field.type}}
                  data-custom-field-type={{field.type}}
                >
                  <span class="circles-info__custom-field-name">
                    {{field.name}}
                  </span>
                  <span class="circles-info__custom-field-value">
                    {{field.value}}
                  </span>
                </div>
              </div>
            {{/if}}
          {{/each}}

          <div class="circles-info__actions">
            {{#if @controller.showMembershipButton}}
              <CirclesMembershipButton
                class="circles-info__actions-membership-button"
                @model={{@model}}
                @showLogin={{routeAction "showLogin"}}
                @disableManageAction={{true}}
              />
            {{/if}}
          </div>
        </div>
      </div>

      <div class="circles-content">
        <section class="circles-content__primary-navigation">
          <CirclesViewNavigationTabs
            @model={{@model}}
            @currentPath={{@controller.currentPath}}
            @tabs={{@controller.displayedTabs}}
          />
          <CirclesMemberActions
            @model={{@model}}
            @canCreateTopic={{@controller.canCreateTopic}}
          />
        </section>

        {{outlet}}
      </div>
    </div>
  </PluginOutlet>
</template>;

export default CircleIndex;
